import React from 'react';

interface Feature {
  text: string;
  included: boolean;
}

interface PricingCardProps {
  title: string;
  price: number;
  period: string;
  features: Feature[];
  isPopular?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({ title, price, period, features, isPopular }) => {
  return (
    <div className={`bg-white p-8 rounded-lg border ${isPopular ? 'border-black' : 'border-gray-200'}`}>
      {isPopular && (
        <span className="bg-black text-white text-sm px-3 py-1 rounded-full">
          Most popular
        </span>
      )}
      <h3 className="text-xl font-semibold mt-4">{title}</h3>
      <div className="mt-4">
        <span className="text-4xl font-bold">${price}</span>
        <span className="text-gray-500">/{period}</span>
      </div>
      <button
        className={`w-full mt-6 py-2 px-4 rounded-lg ${
          isPopular
            ? 'bg-black text-white'
            : 'bg-white text-black border border-gray-200'
        }`}
      >
        Get started
      </button>
      <div className="mt-8">
        <h4 className="font-semibold mb-4">FEATURES</h4>
        <ul className="space-y-3">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center">
              {feature.included ? (
                <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
              ) : (
                <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                </svg>
              )}
              <span className={`ml-3 ${feature.included ? 'text-black' : 'text-gray-500'}`}>
                {feature.text}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PricingCard;
